import { render } from "./ManageBaseOrder.vue?vue&type=template&id=dbfe9880&scoped=true"
import script from "./ManageBaseOrder.vue?vue&type=script&lang=js"
export * from "./ManageBaseOrder.vue?vue&type=script&lang=js"

import "./ManageBaseOrder.vue?vue&type=style&index=0&id=dbfe9880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfe9880"]])

export default __exports__